<template>
  <div>
    <div v-if="!loading" class="article__form-control">
      <div
        v-if="isCreateMode"
        ref="searchable_dropdown"
        class="searchable_dropdown"
        @click="handleClickInside"
      >
        <input
          v-model="searchQuery"
          type="text"
          placeholder="Search..."
          @input="filterArticles"
          @focus="showDropdown"
        />
        <div v-if="isDropdownVisible" class="dropdown">
          <div v-if="filteredArticles.length > 0" class="dropdown-articles">
            <div
              v-for="article in filteredArticles"
              :key="article.id"
              @click="selectArticle(article)"
            >
              {{ article.title }}
            </div>
          </div>
          <div v-else class="no-results">No results found</div>
        </div>
      </div>
      <span class="article__error">{{ errors.article_id.join() }}</span>
    </div>
    <LoaderComponent v-else class="article-loader" />

    <div class="article__form-button">
      <button
        v-if="isCreateMode"
        class="article__button"
        @click="createVideoResourceArticle"
      >
        {{ $vueTranslate('admin.article.add_btn') }}
      </button>
    </div>

    <div
      v-if="isShowMode"
      ref="videoResourceContainer"
      class="document__container"
    >
      <span class="article__title"> {{ video_resource.article_title }}</span>

      <div class="document__delete" @click.stop="deleteVideoResourceArticle">
        <div class="document__delete-icon" />
      </div>
    </div>
  </div>
</template>

<script>
import ArticlesApiService from '../services/articlesApi.service'
import { EMITTERS } from '../../../shared/utils/emitters'
import {
  THEMES,
  VIDEO_RESOURCES_MODES as MODES,
} from '../../../shared/utils/view_options'
import LoaderComponent from '../../../shared/components/Loader'

export default {
  name: 'ArticleComponent',
  components: { LoaderComponent },
  props: {
    theme: {
      default: THEMES.DARK,
      type: String,
    },
    active: {
      type: Number,
      default: null,
    },
    mode: {
      type: String,
      default: MODES.SHOW,
    },
    video_resource: {
      id: Number | null,
      article_id: Number | null,
      article_title: String,
    },
  },
  emits: [EMITTERS.ARTICLE_CREATED_EMITTER, EMITTERS.ARTICLE_DELETED_EMITTER],
  data() {
    return {
      searchQuery: '',
      isDropdownVisible: false,
      selectedArticleId: null,
      videoResourcesArticle: this.video_resource,
      loading: true,
      errors: {
        article_id: [],
      },
    }
  },
  computed: {
    isCreateMode() {
      return this.mode === MODES.CREATE
    },
    isShowMode() {
      return this.mode === MODES.SHOW
    },
    filteredArticles() {
      return this.articles.filter((article) =>
        article.title.toLowerCase().includes(this.searchQuery.toLowerCase())
      )
    },
  },
  created() {
    this.fetchArticles()
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
  },
  methods: {
    fetchArticles() {
      ArticlesApiService.getArticles()
        .then((response) => {
          this.articles = response.data
        })
        .catch(console.error)
        .finally(() => {
          this.loading = false
        })
    },
    createVideoResourceArticle() {
      ArticlesApiService.createVideoResourceArticles(
        this.selectedArticleId,
        this.optional_params
      )
        .then((response) => {
          this.$emit(
            EMITTERS.ARTICLE_CREATED_EMITTER,
            response.data.video_resources_article
          )
          this.clearForm()
          this.clearErrors()
        })
        .catch((e) => {
          this.updateErrors(e)
        })
    },
    deleteVideoResourceArticle() {
      ArticlesApiService.deleteVideoResourceArticle(
        this.videoResourcesArticle,
        this.optional_params
      )
        .then(() => {
          this.$emit(
            EMITTERS.ARTICLE_DELETED_EMITTER,
            this.videoResourcesArticle
          )
        })
        .catch(console.error)
    },
    updateErrors(e) {
      this.errors.article_id =
        e.response.data.errors.article_id ||
        e.response.data.errors.article ||
        []
    },
    clearForm() {
      this.searchQuery = ''
      this.selectedArticleId = null
      this.isDropdownVisible = false
    },
    clearErrors() {
      this.errors.article_id = []
    },
    filterArticles() {
      this.isDropdownVisible = true
    },
    showDropdown() {
      this.isDropdownVisible = true
    },
    selectArticle(article) {
      this.searchQuery = article.title
      this.selectedArticleId = article.id
      this.isDropdownVisible = false
    },
    handleClickInside(event) {
      event.stopPropagation()
    },
    handleOutsideClick(event) {
      if (
        this.$refs.searchable_dropdown &&
        !this.$refs.searchable_dropdown.contains(event.target)
      ) {
        this.isDropdownVisible = false
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import '../../../shared/assets/styles/video_resources';
@import '../../../shared/assets/styles/document';
@import '../../../shared/assets/styles/article';

.article__title {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  width: 90%;
}

.article-loader {
  margin: 50px auto;
  width: 200px;
  display: flex;
  vertical-align: middle;
}
</style>
